import { useState, useEffect } from 'react';

interface UseEnrollmentTutorialModalProps {}

const useEnrollmentTutorialModal = (props: UseEnrollmentTutorialModalProps) => {
  const [showTutorialModal, setShowTutorialModal] = useState(false);

  useEffect(() => {
    // Check if modal has been shown before
    const tutorialShown = localStorage.getItem('academix-enrollment-tutorial-shown');
    if (!tutorialShown) {
      setShowTutorialModal(true);
    }
  }, []); // Only run on mount

  const handleTutorialModalClose = () => {
    setShowTutorialModal(false);
  };

  return {
    showTutorialModal,
    handleTutorialModalClose,
  };
};

export default useEnrollmentTutorialModal;
